import { create } from "zustand";

type NavigationStore = {
  currentPath: string;
  navigateTo: (path: string) => void;
};

export const useNavigationStore = create<NavigationStore>((set) => ({
  currentPath: "/",
  navigateTo: (path: string) => {
    set({ currentPath: path });
  },
}));
